import React, { Component } from "react";
import ReactDOM from "react-dom";
import { FormGroup, Input, Modal, ModalHeader, ModalBody } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { connect } from "react-redux";
import {
  QuotationChecked,
  ApprovedQuantity,
} from "../../../store/CompareQuotation/actions";

class VendorCellRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cellValue: VendorCellRenderer.getValueToDisplay(props),
      showQualitiesModal: false,
    };
    this.toggleQualitiesModal = this.toggleQualitiesModal.bind(this);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const cellValue = VendorCellRenderer.getValueToDisplay(nextProps);
    return {
      cellValue: cellValue,
      showQualitiesModal: prevState.showQualitiesModal,
    };
  }

  toggleQualitiesModal() {
    this.setState((prev) => ({
      showQualitiesModal: !prev.showQualitiesModal,
    }), () => {
    });
  }

  getReactContainerStyle() {
    return { height: "100%" };
  }

  getCheckedRequest(e, index, vendorId) {
    this.props.QuotationChecked(e.target.checked, index, vendorId);
  }

  ChangeHandeler(e, index, vendorId) {
    this.props.ApprovedQuantity(e.target.value, index, vendorId);
  }

  renderQualities() {
    const qualities = this.state.cellValue?.qualities;

    if (!qualities || qualities.length === 0) {
      return <small className="text-muted">No qualities</small>;
    }

    const first = qualities[0];
    const extraCount = qualities.length - 1;

    return (
      <div style={{ fontSize: "11px", display: "flex", alignItems: "center", gap: "8px" }}>
        <span
          style={{
            display: "inline-block",
            maxWidth: "140px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            verticalAlign: "middle",
            color: "#495057",
          }}
          title={first.name}
        >
          • {first.name}
        </span>

        <span
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            this.toggleQualitiesModal();
          }}
          onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          style={{
            color: "#556ee6",
            cursor: "pointer",
            fontSize: "11px",
            fontWeight: "600",
            textDecoration: "underline",
            whiteSpace: "nowrap",
            userSelect: "none",
            padding: "2px 4px",
            borderRadius: "2px",
          }}
        >
          {extraCount > 0 ? `+${extraCount} more` : "view"}
        </span>
      </div>
    );
  }

  renderQualitiesModal() {
    const qualities = this.state.cellValue?.qualities || [];

    // Portal renders modal outside ag-grid DOM tree entirely
    return ReactDOM.createPortal(
      <Modal
        isOpen={this.state.showQualitiesModal}
        toggle={this.toggleQualitiesModal}
        centered
        size="md"
        zIndex={99999}
        backdrop={true}
        keyboard={true}
      >
        <ModalHeader toggle={this.toggleQualitiesModal}>
          <i className="mdi mdi-star-circle mr-2 text-primary"></i>
          Qualities
        </ModalHeader>
        <ModalBody>
          {qualities.length === 0 ? (
            <p className="text-muted text-center">No qualities available.</p>
          ) : (
            <ul style={{ paddingLeft: "20px", margin: 0 }}>
              {qualities.map((q, index) => (
                <li
                  key={q.id}
                  style={{
                    marginBottom: "10px",
                    fontSize: "13px",
                    lineHeight: "1.6",
                    color: "#495057",
                    borderBottom:
                      index < qualities.length - 1
                        ? "1px solid #f1f1f1"
                        : "none",
                    paddingBottom: "8px",
                  }}
                >
                  {q.name}
                </li>
              ))}
            </ul>
          )}
        </ModalBody>
      </Modal>,
      document.body, // ✅ renders outside ag-grid DOM
    );
  }

  render() {
    if (this.state.cellValue != null) {
      if (typeof this.state.cellValue === "string") {
        return (
          <div className="CompareBox">
            <FormGroup className="mb-0">
              <Input
                type="textarea"
                className="form-control"
                placeholder="Enter Terms & Conditions"
                rows="14"
                disabled={true}
                value={this.state.cellValue}
              />
            </FormGroup>
          </div>
        );
      } else {
        return (
          <div className="CompareBox">
            {/* Modal rendered via portal to document.body */}
            {this.renderQualitiesModal()}
            <AvForm>
              <ul className="list-style-Compare p-0">
                <li className="clearfix">
                  <div className="QuotationCheck">
                    <AvField
                      type="checkbox"
                      name="QuotationCheckbox"
                      value={this.props.value?.Quotationcheck}
                      disabled={parseFloat(this.state.cellValue?.balance_qty) === 0}
                      onChange={(e) => {
                        this.getCheckedRequest(
                          e,
                          this.state.cellValue?.index,
                          this.state.cellValue?.vendorId,
                        );
                      }}
                    />
                    {parseFloat(this.state.cellValue?.balance_qty) === 0 && (
                      <small className="text-danger">Balance qty is 0</small>
                    )}
                  </div>
                </li>

                <li className="clearfix mt-3">
                  <span className="ttl">Quantity:</span>
                  <span className="dtl">
                    {this.props.value?.Quantity} {this.props.value?.unit?.name}
                  </span>
                </li>

                <li className="clearfix">
                  <span className="ttl">Base Price:</span>
                  <span className="dtl">{this.state.cellValue?.baseprice}</span>
                </li>

                <li className="clearfix">
                  <span className="ttl">Price (After Discount):</span>
                  <span className="dtl">
                    {this.state.cellValue?.Price} (
                    {this.state.cellValue?.discountpercent}%)
                  </span>
                </li>

                <li className="clearfix">
                  <span className="ttl">Gross Value:</span>
                  <span className="dtl">
                    {this.state.cellValue?.GrossValue}
                  </span>
                </li>

                <li className="clearfix">
                  <span className="ttl">Tax:</span>
                  <span className="dtl">
                    {this.state.cellValue?.taxtype === 1
                      ? "Inclusive"
                      : "Exclusive"}{" "}
                    ({this.state.cellValue?.GST})
                  </span>
                </li>

                <li className="clearfix">
                  <span className="ttl">PO Qty:</span>
                  <span className="dtl">
                    {this.state.cellValue?.po_qty}{" "}
                    {this.props.value?.unit?.name}
                  </span>
                </li>

                <li className="clearfix">
                  <span className="ttl">Tax Amount:</span>
                  <span className="dtl">{this.state.cellValue?.taxamount}</span>
                </li>

                <li className="clearfix mt-2">
                  <span className="ttl">Net Value:</span>
                  <span className="dtl">
                    {this.state.cellValue?.updateGrossValue}
                  </span>
                </li>

                <li className="clearfix">
                  <span className="ttl">Qualities:</span>
                  <span className="dtl">{this.renderQualities()}</span>
                </li>

                <li className="clearfix">
                  <span className="ttl">Approved Quantity:</span>
                  <span className="dtl">
                    {this.state.cellValue?.Quotationcheck === true ? (
                      <div className="Quantity-input">
                        <FormGroup className="mb-0">
                          <AvField
                            className="pr-0"
                            placeholder="qty"
                            type="text"
                            name="ApprovedQuantity"
                            id="ApprovedQuantity"
                            value={this.state.cellValue?.ApprovedQuantity}
                            onKeyDown={(e) => {
                              const allowed = ['Backspace','Delete','Tab','ArrowLeft','ArrowRight','Home','End'];
                              if (allowed.includes(e.key)) return;
                              if (e.key === '.' && !e.target.value.includes('.')) return;
                              if (e.key >= '0' && e.key <= '9') return;
                              e.preventDefault();
                            }}
                            onPaste={(e) => {
                              const paste = e.clipboardData.getData('text');
                              if (!/^[0-9]*\.?[0-9]*$/.test(paste)) e.preventDefault();
                            }}
                            validate={{
                              required: {
                                value: true,
                                errorMessage: "Please enter Qty",
                              },
                              max: {
                                value: parseFloat(
                                  this.state.cellValue?.balance_qty,
                                ),
                                errorMessage:
                                  "Please enter max " +
                                  parseFloat(this.state.cellValue?.balance_qty),
                              },
                              pattern: {
                                value: "^[0-9]{1,18}(\\.?)[0-9]{0,3}$",
                                errorMessage:
                                  "Qty can compose numbers and 3 decimals",
                              },
                            }}
                            onChange={(e) =>
                              this.ChangeHandeler(
                                e,
                                this.state.cellValue?.index,
                                this.state.cellValue?.vendorId,
                              )
                            }
                          />
                        </FormGroup>
                      </div>
                    ) : (
                      this.state.cellValue?.ApprovedQuantity
                    )}
                  </span>
                </li>
              </ul>
            </AvForm>
          </div>
        );
      }
    } else {
      return (
        <div className="CompareBox">
          <div className="box-bg" style={{ width: "100%", height: "260px" }}>
            <div className="containerbackground">
              <span className="font-size-20">Not submitted</span>
            </div>
          </div>
        </div>
      );
    }
  }

  static getValueToDisplay(params) {
    return params.valueFormatted ? params.valueFormatted : params.value;
  }
}

export default connect(null, {
  QuotationChecked,
  ApprovedQuantity,
})(VendorCellRenderer);
